import {createSlice} from "@reduxjs/toolkit"
import axios from "axios";
import { Crypto } from "utils/Crypto";
import { decodeJWT } from "utils/decodeJWT";
import { isValidJSON } from "utils/isValidJSON";

export type AuthStateType={
    user:UserType|null
}


const setupInitialState=():AuthStateType=>{



    let auth:any = localStorage.getItem("auth-"+process.env.REACT_APP_NAME+"-client");

    
    if( auth ){
        
        auth =Crypto({proce:"decrypt",data:auth});
        if(isValidJSON(auth)){
            auth=JSON.parse(auth);
        }
    }
    
    try {
        if((auth as {token:string})){
            const data = decodeJWT(auth.token);
            if(new Date().getTime()<(data?.exp||0)*1000){
                axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
                return {user:(auth as {user:any}).user}
            }else {
                return {user:null}
            }
        }else {
            return {user:null}
        }

    } catch (error) {
        return {user:null};
    }
}


export const authSlice = createSlice({
    name:"auth",
    initialState:setupInitialState(),
    reducers:{
        setUser:(state,action)=>{
            const {user,token}=action.payload;
            if(user){

                if(token){

                    axios.defaults.headers.common['Authorization'] = `Bearer ${action.payload.token}`;
                    localStorage.setItem("auth-"+process.env.REACT_APP_NAME+"-client",Crypto({proce:"encrypt",data:JSON.stringify({user,token})}));
                    state.user=user;
                    return ;
                
                }else {
                    
                    let auth:any = localStorage.getItem("auth-"+process.env.REACT_APP_NAME+"-client");
                    
                    if( auth ){
                        auth =Crypto({proce:"decrypt",data:auth});
                        if(isValidJSON(auth)){
                            auth=JSON.parse(auth);
                        }
                    }


                    auth.user = user;
                    localStorage.setItem("auth-"+process.env.REACT_APP_NAME+"-client",Crypto({proce:"encrypt",data:JSON.stringify(auth)}));
                    state.user=user;
                    return ;
                }
            }else {
                axios.defaults.headers.common['Authorization'] = `Bearer `;
                localStorage.removeItem("auth-"+process.env.REACT_APP_NAME+"-client");
                state.user=null;
            }
        }
    }
})



export const{setUser}=authSlice.actions;
export const authReducer =authSlice.reducer;